export function constructSheetTitleNumber(sheetNumberPrefix?: string, sheetNumber?: string): string {
  if (!!sheetNumberPrefix && !!sheetNumber) {
    return `${sheetNumberPrefix}-${sheetNumber}`;
  }

  return sheetNumberPrefix || sheetNumber || "";
}
